import { j as C } from "../../_virtual/jsx-runtime.js";
const n = ({
  width: H = 20,
  height: V = 20,
  viewBox: r = "0 0 20 20",
  fill: o = "currentColor",
  ...s
}) => /* @__PURE__ */ C.jsx(
  "svg",
  {
    width: H,
    height: V,
    viewBox: r,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...s,
    children: /* @__PURE__ */ C.jsx(
      "path",
      {
        d: "M2.5 3.33333C2.5 2.8731 2.8731 2.5 3.33333 2.5H8.33333C8.79358 2.5 9.16667 2.8731 9.16667 3.33333V8.33333C9.16667 8.79358 8.79358 9.16667 8.33333 9.16667H3.33333C2.8731 9.16667 2.5 8.79358 2.5 8.33333V3.33333ZM2.5 11.6667C2.5 11.2064 2.8731 10.8333 3.33333 10.8333H8.33333C8.79358 10.8333 9.16667 11.2064 9.16667 11.6667V16.6667C9.16667 17.1269 8.79358 17.5 8.33333 17.5H3.33333C2.8731 17.5 2.5 17.1269 2.5 16.6667V11.6667ZM10.8333 3.33333C10.8333 2.8731 11.2064 2.5 11.6667 2.5H16.6667C17.1269 2.5 17.5 2.8731 17.5 3.33333V8.33333C17.5 8.79358 17.1269 9.16667 16.6667 9.16667H11.6667C11.2064 9.16667 10.8333 8.79358 10.8333 8.33333V3.33333ZM10.8333 11.6667C10.8333 11.2064 11.2064 10.8333 11.6667 10.8333H16.6667C17.1269 10.8333 17.5 11.2064 17.5 11.6667V16.6667C17.5 17.1269 17.1269 17.5 16.6667 17.5H11.6667C11.2064 17.5 10.8333 17.1269 10.8333 16.6667V11.6667ZM12.5 4.16667V7.5H15.8333V4.16667H12.5ZM12.5 12.5V15.8333H15.8333V12.5H12.5ZM4.16667 4.16667V7.5H7.5V4.16667H4.16667ZM4.16667 12.5V15.8333H7.5V12.5H4.16667Z",
        fill: o
      }
    )
  }
);
export {
  n as default
};
